import { DataState } from '@betty/toolkit/state';
import { Limit } from '../services/LimitsService.schemas';

export type Limits = {
  data: Limit[] | null;
  dataState: DataState;
  updateLimitsDataState: DataState;
};

export enum LimitsErrorCode {
  ValidationError = 'validation-error',
  GenericError = 'generic-error',
}

export type UpdateLimitsErrorPayload =
  | {
      data: {
        errorCode: LimitsErrorCode;
      };
    }
  | undefined;
